import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormItem } from '../form/FormItem';
import { FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'vias-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  @Input() item: FormItem;
  @Input() form: FormGroup;
  @Output() onchange: EventEmitter<object> = new EventEmitter<object>();
  constructor() { }
  ngOnInit(): void { }
  onChange($event: MatCheckboxChange): void {
    if (this.item.toggleFormItems !== undefined) {
      this.item.toggleFormItems.forEach(tItemName => {
        if (this.form.controls[tItemName].disabled) {
          this.form.controls[tItemName].enable();
        } else {
          this.form.controls[tItemName].disable();
        }
      });
    }

    this.onchange.emit($event);
  }
}
